import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import map from 'lodash/map';
import size from 'lodash/size';
import groupBy from 'lodash/groupBy';
import round from 'lodash/round';
import findIndex from 'lodash/findIndex';

import Button from '../common/Button';
import QuotesCard from './QuotesCard';
import Gmaps from './Gmaps';
import JobDetails from './JobDetails';
import InputRange from 'react-input-range';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import { DropdownButton, Media } from 'react-bootstrap';
import AcceptedQuotes from './AcceptedQuotes';
import CarType from './CarType';
import Rating from 'react-rating';
import CustomScroll from 'react-custom-scroll';
import PageLoader from '../common/PageLoader';
import TimePicker from 'rc-time-picker';
import moment from 'moment';
import { imageBasePath, appBasePath } from '../../constants/staticData';


export default class RequestCard extends Component {
  constructor(...args) {
    super(...args);
    this.toggleSwitchVal = { Open24_7: false, showFavourites: false, byCash: false, byCreditcard: false };
    const currentRoute = this.props.router.getCurrentLocation();
    const jobid = (currentRoute.query && currentRoute.query.jobid) ? currentRoute.query.jobid : undefined;
    const garage_id = (currentRoute.query && currentRoute.query.garage_id) ? currentRoute.query.garage_id : undefined;
    this.state = {
      mobJD:'job-card',
      locationSearch: {
        lat: undefined,
        lng: undefined,
        pinImage: ""
      },
      isButtonLoading: false,
      isLoading: true,
      filterdropdownVisible: false,
      dataChange: "",
      setCenter: false,
      mapsCenter: { lat: 12.9952672, lng: 77.5905857 },
      switched: false,
      filterSort: "dateNO",
      filterdropdown: false,
      pollCountObj: '',
      batchId: '',
      now: moment(),
      sortBydropdown: false,
      daySelected: {
        "sunday": false, "monday": false, "tuesday": false, "wednesday": false, "thrusday": false, "friday": false, "saturday": false
      },
      daySelectedKey: [false, false, false, false, false, false, false],
      daySelectedValue: [],
      changedWeek: false,
      filterType: "",
      open: false,
      rangeFromDefault: moment('2016-12-19T00:00:00+05:30'),
      rangeToDefault: moment('2016-12-19T23:59:00+05:30'),
      rangefrom: undefined,
      rangeto: undefined,
      jobUpdates: jobid ? "quotes" : "details",
      currentWidth: '',
      activelatitude: '',
      activelongitue: '',
      jobCardDetails: [],
      quotation: false,
      messages: true,
      mapView: true,
      quotationView: false,
      activeSvg: 'data:image/svg+xml,%3Csvg%20width%3D%2236px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2036%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2042%20%2836781%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3Elocation-pin%20copy%209%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C3.99742905%20C0%2C1.78970995%201.7852456%2C0%203.99017859%2C0%20L32.0098214%2C0%20C34.2135362%2C0%2036%2C1.78197514%2036%2C3.99742905%20L36%2C25.1917601%20C36%2C27.3994792%2034.4851438%2C30.1580906%2032.6302879%2C31.3444558%20L19.0975342%2C40%20L3.48057588%2C31.1594879%20C1.5583069%2C30.071322%200%2C27.407214%200%2C25.1917601%20L0%2C3.99742905%20Z%22%20id%3D%22path-1%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20maskContentUnits%3D%22userSpaceOnUse%22%20maskUnits%3D%22objectBoundingBox%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2240%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C/use%3E%0A%20%20%20%20%20%20%20%20%3C/mask%3E%0A%20%20%20%20%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-opacity%3D%220.455219656%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22location-pin-copy-9%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%224%22%20fill%3D%22%2323AE49%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Rectangle-10-Copy-3%22%20mask%3D%22url%28%23mask-2%29%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C/use%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3Ctext%20transform%3D%22translate%2818.5%2021%29%22%20fill%3D%22%23fff%22%20style%3D%22font-family%3A%20Arial%2C%20sans-serif%3Bfont-weight%3Abold%3Btext-align%3Acenter%3B%22%20font-size%3D%2212%22%20text-anchor%3D%22middle%22%3E',
      svg: 'data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2236px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2036%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2042%20(36781)%20-%20http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch%20--%3E%0A%20%20%20%20%3Ctitle%3ERectangle%2010%20Copy%203%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C3.99742905%20C0%2C1.78970995%201.7852456%2C0%203.99017859%2C0%20L32.0098214%2C0%20C34.2135362%2C0%2036%2C1.78197514%2036%2C3.99742905%20L36%2C25.1917601%20C36%2C27.3994792%2034.4851438%2C30.1580906%2032.6302879%2C31.3444558%20L19.0975342%2C40%20L3.48057588%2C31.1594879%20C1.5583069%2C30.071322%200%2C27.407214%200%2C25.1917601%20L0%2C3.99742905%20Z%22%20id%3D%22path-1%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20maskContentUnits%3D%22userSpaceOnUse%22%20maskUnits%3D%22objectBoundingBox%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2240%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-opacity%3D%220.455219656%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22location-pin%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%224%22%20fill%3D%22%23EE3124%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Rectangle-10-Copy-3%22%20mask%3D%22url(%23mask-2)%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Ctext%20transform%3D%22translate(18.5%2021)%22%20fill%3D%22%23fff%22%20style%3D%22font-family%3A%20Arial%2C%20sans-serif%3Bfont-weight%3Abold%3Btext-align%3Acenter%3B%22%20font-size%3D%2212%22%20text-anchor%3D%22middle%22%3E',
      svgEnd: '</text>%0A</svg>',
      distValue: { min: 0, max: 20 },
      priceValue: { min: 0, max: 100 },
      selectedVendorId: garage_id || 0,
      ratingValue: 0,
      inValidTime: false,
      selectedJobId: jobid || undefined,
      sortValue: "distance",
      filterActivated: undefined,
    };
    this.removeFav = this.removeFav.bind(this);
    this.acceptQuotes = this.acceptQuotes.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.windowWidth = this.windowWidth.bind(this);
    this.sortBy = this.sortBy.bind(this);
    this.viewMessaging = this.viewMessaging.bind(this);
    this.filterSelect = this.filterSelect.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
  }

  componentWillMount() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.showPosition.bind(this));
    } else {
      alert("Geolocation is not supported by this browser.");
    }
    this.updateDimensions();
    window.addEventListener('mousedown', this.bodyClick.bind(this));
    // if (this.props.jobType == 'waiting' || this.props.jobType == undefined) {
    //   this.setState({ jobUpdates: "details" })
    // }
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    // if (this.props.jobType == 'waiting' || this.props.jobType == undefined) {
    //   this.setState({ jobUpdates: "details" })
    // }
    const currentRouteLocation = this.props.router.getCurrentLocation();
    if (currentRouteLocation.query && (currentRouteLocation.query.view == "message")) {
      this.viewMessaging();
    } else if (currentRouteLocation.query && (currentRouteLocation.query.view == "quotes")) {
      this.jobDetail('quotes');
      this.viewQuotation();

    }
    // if (this.props.jobType == 'active') {
    //   this.setState({ mapView: true, quotationView: false })
    // }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
    window.removeEventListener('mousedown', this.bodyClick.bind(this))
  }

  jobDetail(val) {
    this.setState({ jobUpdates: val });
  }

  showPosition(position) {
    let positionVal = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
      pinImage: `${imageBasePath}/images/map_blue_pointer.png`
    };
    this.setState({ locationSearch: positionVal })
  }

  bodyClick(e) {
    if ((e.target.closest('.filter-dropdown') || e.target.closest('.showFilters')) && (!this.state.filterdropdown)) {
      this.setState({ filterdropdown: true, sortBydropdown: false });
    } else if ((e.target.closest('.showSortBy') || e.target.closest('.sortFilter')) && (!this.state.sortBydropdown)) {
      this.setState({ sortBydropdown: true, filterdropdown: false });
    } else if (e.target.closest('.rc-time-picker-panel')) {
      this.setState({ filterdropdown: true, sortBydropdown: false });
    }
    else if (e.target.closest('.Filterby') == null && e.target.closest('.sortFilter') == null) {
      this.setState({ filterdropdown: false, sortBydropdown: false });
    }
  }

  filterDropDownFunc(e) {
    if (!this.state.filterdropdownVisible) {
      this.setState({ filterdropdown: e });
    }
  }

  updateDimensions() {
    const windowWidth = this.windowWidth();
    this.setState({ 'currentWidth': windowWidth });
  }

  windowWidth() {
    let docElemProp = window.document.documentElement.clientWidth,
      body = window.document.body;
    return window.document.compatMode === "CSS1Compat" && docElemProp || body && body.clientWidth || docElemProp;
  }
  btnClickFunc(requestId, jobId) {
    // this.props.actions.getQuotesPricingDetails(requestId, jobId);
    this.setState({ mapView: false, selectedJobId: jobId, quotationView: true, quotation: true, messages: false })
    if(this.state.currentWidth<991){
      this.viewQuotation()
    }
  }
  viewMessaging(jobId) {
    this.setState({ mapView: true, quotationView: false });
  }
  mapClick(map) {
    let update, newDetails = [];
    this.state.jobCardDetails.map((value, key) => {
      if (value.garage && (round(Number(value.garage.latitude), 6) == round(map.latLng.lat(), 6) && round(Number(value.garage.longitude), 6) == round(map.latLng.lng(), 6))) {
        update = { ...value, pinImage: this.state.activeSvg + key + this.state.svgEnd, isActive: true, zIndex: 999 };
      } else {
        update = { ...value, pinImage: this.state.svg + key + this.state.svgEnd, isActive: false, zIndex: 9 };
      }
      newDetails.push(update);
    });
    this.setState({
      jobCardDetails: newDetails,
    });
    this.setState({
      scrollTo: Object.keys(this.currentTopEle).length > 0 ? ReactDOM.findDOMNode(this.currentTopEle).getBoundingClientRect().top : 0
    });
  }
  ClickedQuoteCard(key, vendorId) {
    let update, newArray = [], centerLat = undefined, centerLng = undefined;
    map(this.state.jobCardDetails, (val, index) => {
      if (val.garage && val.garage.id == vendorId) {
        update = { ...val, isActive: true, pinImage: this.state.activeSvg + index + this.state.svgEnd, zIndex: 999 }
        centerLat = val.garage.latitude, centerLng = val.garage.longitude;
      } else {
        update = { ...val, isActive: false, pinImage: this.state.svg + index + this.state.svgEnd, zIndex: 9 }
      }
      newArray.push(update);
    });
    this.setState({
      jobCardDetails: newArray,
      selectedVendorId: vendorId,
      mapsCenter: { lat: centerLat, lng: centerLng },
      setCenter: true
    });
  }
  closeChat() {
    this.setState({ mapView: true, quotationView: false });
  }
  viewQuotation() {
    this.setState({ mapView: false, quotationView: true, quotation: true, mobJD:"" });
  }
  viewMessages() {
    this.setState({ mapView: true, quotationView: false, quotation: false, mobJD:"" });
  }

  day(selDay, day) {
    let days = { ...this.state.daySelected };
    let daysValue = [...this.state.daySelectedKey];
    days[selDay] = !this.state.daySelected[selDay];
    daysValue[day] = !this.state.daySelectedKey[day];
    this.setState({
      daySelected: days,
      daySelectedKey: daysValue,
    });
  }

  sortBy(jobId, value) {
    // this.props.actions.getVendorQuotesList(jobId, value);
  }

  filterOption(val, sortValue) {
    this.setState({
      filterSort: val,
      sortBydropdown: false,
      sortValue: sortValue,
    });
  }

  clearFilter(jobId) {
    this.toggleSwitchVal = { Open24_7: false, showFavourites: false, byCash: false, byCreditcard: false };
    this.setState({
      ratingValue: 0,
      inValidTime: false,
      TimePickerFrom: undefined,
      daySelectedValue: [],
      daySelectedKey: [false, false, false, false, false, false, false],
      TimePickerTo: undefined,
      rangefrom: undefined,
      rangeto: undefined,
      filterActivated: false,
      rangeFromDefault: moment('2016-12-19T00:00:00+05:30'),
      rangeToDefault: moment('2016-12-19T23:59:00+05:30'),
      distValue: { min: 0, max: 20 },
      priceValue: { min: 0, max: 100 },
      daySelected: {
        "sunday": false, "monday": false, "tuesday": false, "wednesday": false, "thrusday": false, "friday": false, "saturday": false
      }
    });
    // this.props.actions.getVendorQuotesList(jobId, this.state.sortValue, this.state.distValue, this.state.priceValue, this.state.daySelectedValue, this.state.rangefrom, this.state.rangeto, this.state.ratingValue, this.toggleSwitchVal);
  }

  switch(val) {
    this.toggleSwitchVal[val] = !this.toggleSwitchVal[val];
    if (val == 'byCash') {
      this.toggleSwitchVal.byCreditcard = false;
    } else if (val == 'byCreditcard') {
      this.toggleSwitchVal.byCash = false;
    }
    this.setState({ switched: !this.state.switched });
  }

  rangefrom(value) {
    this.setState({
      rangefrom: value.format("hh:mm A"),
      rangeFromDefault: value
    });
  }

  rangeTo(value) {
    this.setState({
      rangeto: value.format("hh:mm A"),
      rangeToDefault: value,
    });
  }

  filterSelect(jobId) {
    let daysSelected = [];
    let filterActivated = false;
    map(this.state.daySelectedKey, (value, key) => {
      if (value) {
        daysSelected.push(key + 1);
      }
    });
    if (this.toggleSwitchVal && this.toggleSwitchVal['byCash'] || this.toggleSwitchVal['byCreditcard'] || this.toggleSwitchVal['Open24_7'] || this.state.ratingValue || this.state.distValue && this.state.distValue.min && this.state.distValue.max || this.state.priceValue && this.state.priceValue.min && this.state.priceValue.max || daysSelected.length || this.state.rangefrom || this.state.rangeTo) {
      filterActivated = true;
    }
    this.setState({
      filterdropdown: false,
      daySelectedValue: daysSelected,
      filterActivated: filterActivated,
    });
    // this.props.actions.getVendorQuotesList(jobId, this.state.sortValue, this.state.distValue, this.state.priceValue, daysSelected, this.state.rangefrom, this.state.rangeto, this.state.ratingValue, this.toggleSwitchVal);
  }

  statusIndicatorFunc(status) {
    if (status == 'Completed' || status == 'Accepted' || status == 'In-progress') {
      return "Accepted Quotes";
    } else {
      return "Quotes";
    }
  }

  removeFav(event, status, vendorId, userRequestId) {
    event.stopPropagation();
    event.preventDefault();
    // this.props.actions.changeFavouriteSelection(vendorId, status, 'activeVendors', userRequestId);
  }

  ratingOnChange(rating) {
    this.setState({ ratingValue: rating });
  }

  setCenter() {
    this.setState({ setCenter: true });
  }

  acceptQuotes(id, jobID, requestId, router) {
    this.setState({ isButtonLoading: true });
    // this.props.actions.acceptQuotes(id, jobID, requestId, router);
  }
  changeJobType(){
    this.setState({mobJD:''});
  }

  render() {
    const { jobType, router, actions } = this.props;
    let jobLeftGridValue = "";
    let jobRightGridValue = "";
    if (this.state.currentWidth <= 1155 && this.state.currentWidth >= 992) {
      jobLeftGridValue = "col-md-7";
      jobRightGridValue = "col-md-5";
    } else if (this.state.currentWidth <= 1345 && this.state.currentWidth >= 1155) {
      jobLeftGridValue = "col-md-6";
      jobRightGridValue = "col-md-6";
    } else {
      jobLeftGridValue = "col-md-5";
      jobRightGridValue = "col-md-7";
    }
    let jobData = this.props.bookingRequestData;

    let jobId = jobData && jobData.id;
    let vendorQuotesList = jobData && jobData.vendorQuotesList ? jobData.vendorQuotesList : {};

    let displayname = jobData && jobData.requeststatus && jobData.requeststatus.displayname;
    let vendorIndex = this.state.selectedJobId && findIndex(vendorQuotesList.garagejobquotes, { id: this.state.selectedJobId });
    let garageQuotesPricingDetails = vendorIndex != -1 && vendorQuotesList.garagejobquotes && size(vendorQuotesList.garagejobquotes) && vendorQuotesList.garagejobquotes[vendorIndex];
    garageQuotesPricingDetails = (jobData && displayname == 'Accepted' || displayname == 'In-progress' || displayname == 'Completed') ? jobData.garagejobquotes[0] : garageQuotesPricingDetails;
    let startDate = garageQuotesPricingDetails && new Date(garageQuotesPricingDetails.jobStartDatetime);
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    startDate = startDate && startDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) + ' on ' + months[startDate.getMonth()] + ' ' + startDate.getDate() + ' ' + startDate.getFullYear();
    let createdAt = garageQuotesPricingDetails && new Date(garageQuotesPricingDetails.createdAt);
    createdAt = createdAt && months[createdAt.getMonth()] + ' ' + createdAt.getDate() + ' ' + createdAt.getFullYear();
    let locationIndex = 0;

    let jobCardDetails = [];
    map(vendorQuotesList.garagejobquotes, (value) => {
      jobCardDetails.push(value);
    });
    jobCardDetails && map(jobCardDetails, (value, key) => {
      if (key == 0) {
        jobCardDetails[key] = {
          ...jobCardDetails[key],
          isActive: true
        };
      } else {
        jobCardDetails[key] = {
          ...jobCardDetails[key],
          isActive: false
        };
      }
    });

    const jobCardLocation = map(jobCardDetails, (val, key) => {
      let garage = val && val.garage;
      locationIndex += 1;
      return {
        lat: garage && Number(garage.latitude),
        lng: garage && Number(garage.longitude),
        pinImage: val.isActive ? this.state.activeSvg + (locationIndex) + this.state.svgEnd : this.state.svg + (locationIndex) + this.state.svgEnd,
        name: garage && garage.companyprofilename,
        rating: garage && garage.rating,
        distance: garage && garage.distance,
        review: garage && garage.reviews,
        zIndex: val.zIndex ? val.zIndex : 9,
        image: val.garage.logo,
      };
    });
    let serviceIndex = 0;
    return (
      <div>
        <div className="request-card">
          <div >
            {jobData && <CarType
              source={'requestview'}
              authReducer={this.props.authReducer}
              bookingRequestReducer={this.props.bookingRequestReducer}
              actions={actions} cardDetails={jobData}
              vendorQuotesCount={jobData && jobData.totalJobQuotes}
              jobLeftGridValue={jobLeftGridValue} jobRightGridValue={jobRightGridValue}
              messageClick={(jobId) => { this.viewMessaging(jobId) }} router={router}
              quotesClick={this.jobDetail.bind(this, 'quotes')} />}
          </div>

          <div className="requestSection">
            <div className="row">
              <div className={jobType == "active" ? "request-summary vendor-list-view" : "request-summary"}>
                <div className="row request-summary-header">
                  <div className="col-md-6 col-sm-12 col-xs-12 pad0">
                    <div className="row request-summary-tab">
                      <div className="col-md-6 col-sm-6 col-xs-6 pad0">
                        <div className={this.state.jobUpdates == "details" ? "title active" : "title"} onClick={() => { this.jobDetail('details') }}>
                          <span>Job Details</span>
                        </div>
                      </div>
                      {(displayname != "Waiting" && displayname != "Cancelled" && displayname != "Expired") && <div className="col-md-6 col-sm-6 col-xs-6 pad0">
                        <div className={this.state.jobUpdates == "quotes" ? "title active" : "title"} onClick={() => { this.jobDetail('quotes') }}>
                          {/* <span>{this.jobData[0].statusIndicator=="accepted" || this.jobData[0].statusIndicator=="inProgress" ||this.jobData[0].statusIndicator=="completed" ?"Accepted Quotes":"Quotes"}</span> */}
                          <span>{this.statusIndicatorFunc(displayname)}</span>
                        </div>
                      </div>}
                    </div>
                     {/* {this.state.currentWidth < 991 && this.state.jobUpdates == "quotes" && <div className="mob-view">
                        <div className={this.state.mobJD=="job-card"?"col-md-6 col-sm-6 col-xs-6 pad0":"hide"} onClick={()=>this.setState({mobJD:"job-card"})}>
                          <span>Job Details</span>
                        </div>
                        <div className= {this.state.mobJD==""?"col-md-6 col-sm-6 col-xs-6 pad0":"hide"} onClick={()=>this.viewQuotation()}>
                          <span>Quote</span>
                        </div>
                        <div className= {this.state.mobJD==""?"col-md-4 col-sm-4 col-xs-4 pad0":"hide"} onClick={()=> this.viewMessages()}>
                          <span>Message</span>
                        </div>

                      </div>} */}
                  </div>
                </div>
                <div className="row request-summary-body">
                  {this.state.jobUpdates == "details" && jobData && <div className="tab-jobDetails">
                    <JobDetails displayname={displayname} pollCountObj={this.state.pollCountObj} batchId={this.state.batchId} serviceTypes={jobData.services && jobData.services.name} requestData={jobData} router={router} actions={actions} />
                  </div>}
                  {this.state.jobUpdates == "quotes" && displayname != "Waiting" &&
                    <div className="tab-quotes ">
                      <div className="col-md-6 clearfix left pad0" >
                      <div className= {this.state.currentWidth>991?"quotes-view":this.state.mobJD=="job-card"?"quotes-view":"quotes-view hide"}>
                          {displayname == "Active" && <div className="title">
                            <span className="qv-title">{vendorQuotesList.garagejobquotes && size(vendorQuotesList.garagejobquotes)} Quotes Received</span>
                            <div className="filterSection active">
                              <DropdownButton bsSize="small" id="dropdown-size-small" open={this.state.sortBydropdown} noCaret title={
                                <div className="filterLabel showSortBy">
                                  <i className="mdi mdi-swap-vertical" />
                                  <label>Sort by</label>
                                  <i className={this.state.sortBydropdown ? "mdi mdi-chevron-up downIcon downAlign pull-right" : "mdi mdi-chevron-down downIcon downAlign pull-right"} />
                                </div>
                              }>
                                <div className="sortFilter filterCard">
                                  <ul className="list-unstyled">
                                    <li onClick={() => { (this.filterOption("dateNO", "-date")); this.sortBy(jobId, "-date"); }} className={this.state.filterSort == "dateNO" ? "active" : ""}>
                                      <label>
                                        Quote Date - Newest to Oldest
                                      </label>
                                      <span>
                                        <i className={this.state.filterSort == "dateNO" ? "mdi mdi-check active" : "hide"} />
                                      </span>
                                    </li>
                                    <li onClick={() => { (this.filterOption("dateON", "date")); this.sortBy(jobId, "date"); }} className={this.state.filterSort == "dateON" ? "active" : ""}>
                                      <label>
                                        Quote Date - Oldest to Newest
                                      </label>
                                      <span>
                                        <i className={this.state.filterSort == "dateON" ? "mdi mdi-check active" : "hide"} />
                                      </span>
                                    </li>
                                    <li onClick={() => { (this.filterOption("nameON", "name")); this.sortBy(jobId, "name"); }} className={this.state.filterSort == "nameON" ? "active" : ""}>
                                      <label>
                                        Name - Ascending - Descending
                                      </label>
                                      <span>
                                        <i className={this.state.filterSort == "nameON" ? "mdi mdi-check active" : "hide"} />
                                      </span>
                                    </li>
                                    <li onClick={() => { (this.filterOption("nameNO", "-name")); this.sortBy(jobId, "-name"); }} className={this.state.filterSort == "nameNO" ? "active" : ""}>
                                      <label>
                                        Name - Descending - Ascending
                                      </label>
                                      <span>
                                        <i className={this.state.filterSort == "nameNO" ? "mdi mdi-check active" : "hide"} />
                                      </span>
                                    </li>
                                    <li onClick={() => { (this.filterOption("DistNF", "distance")); this.sortBy(jobId, "distance"); }} className={this.state.filterSort == "DistNF" ? "active" : ""}>
                                      <label>
                                        Distance - Near to Far
                                        </label>
                                      <span>
                                        <i className={this.state.filterSort == "DistNF" ? "mdi mdi-check active" : "hide"} />
                                      </span>
                                    </li>
                                    <li onClick={() => { (this.filterOption("DistFN", "-distance")); this.sortBy(jobId, "-distance"); }} className={this.state.filterSort == "DistFN" ? "active" : ""}>
                                      <label>
                                        Distance - Far to Near
                                        </label>
                                      <span>
                                        <i className={this.state.filterSort == "DistFN" ? "mdi mdi-check active" : "hide"} />
                                      </span>
                                    </li>
                                    <li onClick={() => { (this.filterOption("ratingHL", "-rating")); this.sortBy(jobId, "-rating"); }} className={this.state.filterSort == "ratingHL" ? "active" : ""}>
                                      <label>
                                        Rating - Highest to Lowest
                                        </label>
                                      <span>
                                        <i className={this.state.filterSort == "ratingHL" ? "mdi mdi-check active" : "hide"} />
                                      </span>
                                    </li>
                                    <li onClick={() => { (this.filterOption("ratingLH", "rating")); this.sortBy(jobId, "rating"); }} className={this.state.filterSort == "ratingLH" ? "active" : ""}>
                                      <label>
                                        Rating - Lowest to Highest
                                        </label>
                                      <span>
                                        <i className={this.state.filterSort == "ratingLH" ? "mdi mdi-check active" : "hide"} />
                                      </span>
                                    </li>
                                    <li onClick={() => { (this.filterOption("priceHL", "-price")); this.sortBy(jobId, "-price"); }} className={this.state.filterSort == "priceHL" ? "active" : ""}>
                                      <label>
                                        Price - Highest to Lowest
                                      </label>
                                      <span>
                                        <i className={this.state.filterSort == "priceHL" ? "mdi mdi-check active" : "hide"} />
                                      </span>
                                    </li>
                                    <li onClick={() => { (this.filterOption("priceLH", "price")); this.sortBy(jobId, "price"); }} className={this.state.filterSort == "priceLH" ? "active" : ""}>
                                      <label>
                                        Price - Lowest to Highest
                                      </label>
                                      <span>
                                        <i className={this.state.filterSort == "priceLH" ? "mdi mdi-check active" : "hide"} />
                                      </span>
                                    </li>

                                  </ul>
                                </div>
                              </DropdownButton>
                            </div>
                            <div className={this.state.filterActivated ? "filterSection active" : "filterSection"}>
                              <DropdownButton bsSize="large" open={this.state.filterdropdown} noCaret id="dropdown-size-large" title={
                                <div className="filterLabel showFilters ">
                                  <i className="mdi mdi-filter-variant" />
                                  <label>Filter</label>
                                  <i className={this.state.filterdropdown ? "mdi mdi-chevron-up downIcon pull-right" : "mdi mdi-chevron-down downIcon pull-right"} />
                                </div>
                              }>
                                <li className="Filterby filterCard filter-dropdown">
                                  <div className="filter-left">
                                    <div className="filterby-wrapper">
                                      <div className="f-card n-distance-range">
                                        <h5>Distance</h5>
                                        <InputRange
                                          formatLabel={distValue => `${distValue}km`}
                                          minValue={0}
                                          maxValue={100}
                                          value={this.state.distValue}
                                          onChange={distValue => this.setState({ distValue })} />
                                        <span className="range-min">{this.state.distValue.min + " Km"}</span>
                                        <span className="range-max">{this.state.distValue.max + " Km"}</span>
                                      </div>
                                      <div className="f-card n-distance-range">
                                        <h5>Price</h5>
                                        <InputRange
                                          formatLabel={priceValue => `${priceValue}AED`}
                                          minValue={0}
                                          maxValue={100}
                                          value={this.state.priceValue}
                                          onChange={priceValue => this.setState({ priceValue })} />
                                        <span className="range-min">{this.state.priceValue.min + " AED"}</span>
                                        <span className="range-max">{this.state.priceValue.max + " AED"}</span>
                                      </div>
                                      <div className="f-card openAlign n-time-range">
                                        <h5>Open Between</h5>
                                        <ul className="list-unstyled">
                                          <li className={this.state.daySelected["sunday"] ? 'active' : ''} onClick={this.day.bind(this, "sunday", 0)}>SUN</li>
                                          <li className={this.state.daySelected["monday"] ? 'active' : ''} onClick={this.day.bind(this, "monday", 1)}>MON</li>
                                          <li className={this.state.daySelected["tuesday"] ? 'active' : ''} onClick={this.day.bind(this, "tuesday", 2)}>TUE</li>
                                          <li className={this.state.daySelected["wednesday"] ? 'active' : ''} onClick={this.day.bind(this, "wednesday", 3)}>wed</li>
                                          <li className={this.state.daySelected["thrusday"] ? 'active' : ''} onClick={this.day.bind(this, "thrusday", 4)}>thu</li>
                                          <li className={this.state.daySelected["friday"] ? 'active' : ''} onClick={this.day.bind(this, "friday", 5)}>fri</li>
                                          <li className={this.state.daySelected["saturday"] ? 'active' : ''} onClick={this.day.bind(this, "saturday", 6)}>sat</li>
                                        </ul>
                                        <div className="row date-time model-select date-time-align">
                                          <span className="n-time-from">
                                            <TimePicker
                                              showSecond={false}
                                              className="custom-timepicker"
                                              format={'h:mm a'}
                                              value={this.state.rangeFromDefault}
                                              onChange={this.rangefrom.bind(this)}
                                              defaultValue={moment('2016-12-19T00:00:00+05:30')}
                                              use12Hours
                                            />
                                            <i className="mdi mdi-chevron-down time-to" />
                                          </span>
                                          <span className="time-to-time n-time-to">to</span>

                                          <span className="n-time-to">
                                            <TimePicker
                                              showSecond={false}
                                              className="custom-timepicker"
                                              format={'h:mm a'}
                                              onChange={this.rangeTo.bind(this)}
                                              value={this.state.rangeToDefault}
                                              defaultValue={moment('2016-12-19T23:59:00+05:30')}
                                              use12Hours
                                            />
                                            <i className="mdi mdi-chevron-down time-to" />
                                          </span>
                                          {/* </div> */}
                                        </div>
                                      </div>
                                      <div className="f-card toggleBtn">
                                        <h5>Open 24/7</h5>
                                        <ToggleSwitch
                                          checked={this.toggleSwitchVal.Open24_7}
                                          size="small"
                                          onChange={this.switch.bind(this, 'Open24_7')}
                                          ref={(node) => {
                                            this.toggleSwitch = node;
                                          }} />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="filter-right toggleBtn">
                                    <div className="filterby-wrapper">
                                      <div className="f-card star-rating">
                                        <h5>Rating</h5>
                                        <Rating
                                          empty="mdi mdi-star-outline "
                                          full="mdi mdi-star active-star"
                                          initialRate={this.state.ratingValue}
                                          onChange={(e) => { this.ratingOnChange(e) }}
                                        />
                                      </div>
                                      <div className="f-card ">
                                        <h5>Only show Favourites</h5>
                                        <ToggleSwitch
                                          checked={this.toggleSwitchVal.showFavourites}
                                          size="small"
                                          onChange={this.switch.bind(this, 'showFavourites')}
                                          ref={(node) => {
                                            this.toggleSwitch = node;
                                          }}
                                        />
                                      </div>
                                      <div className="f-card payment-type">
                                        <h5>Payment by</h5>
                                        <div className="holder">
                                          <span className="pad0">Pay by Cash</span>
                                          <ToggleSwitch
                                            checked={this.toggleSwitchVal.byCash}
                                            size="small"
                                            onChange={this.switch.bind(this, 'byCash')}
                                            ref={(node) => {
                                              this.toggleSwitch = node;
                                            }}
                                          />
                                        </div>
                                        <div className="holder">
                                          <span className="">Pay by Credit Card</span>
                                          <ToggleSwitch
                                            checked={this.toggleSwitchVal.byCreditcard}
                                            size="small"
                                            onChange={this.switch.bind(this, 'byCreditcard')}
                                            ref={(node) => {
                                              this.toggleSwitch = node;
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="filter-footer footer">
                                    <a onClick={() => { this.clearFilter(jobId); }}>Clear</a>
                                    <Button btnType="red" btnSize="sm" fontSize={15} label="Apply" btnCallBack={() => this.filterSelect(jobId)} />
                                  </div>
                                </li>
                              </DropdownButton>
                            </div>
                          </div>}
                          <div className="quotes-left-body">
                            <div className={jobData && jobData.requeststatus && (displayname == "Accepted" || displayname == "In-progress" || displayname == "Completed") ? "requestQuotesScroll vendor-details-content" : "requestQuotesScroll"}>
                              <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true} scrollTo={this.state.scrollTo}>
                                {displayname == "Active" && <div className="wrapper" ref={'quotesList'}>
                                  <div>
                                    {jobCardDetails && map(jobCardDetails, (details, key) => {
                                      return (
                                        <QuotesCard
                                          router={router}
                                          isFavourite={details.garage && details.garage.isfavourite}
                                          requestId={vendorQuotesList.id}
                                          userRequestId={vendorQuotesList.requestid}
                                          jobId={details.id}
                                          vendorImage={details.garage && details.garage.logo}
                                          key={key}
                                          price={details && details.totalamount ? details.totalamount + ' ' + details.currency : '-'}
                                          ref={(quotesCard) => { details.isActive ? this.currentTopEle = quotesCard : '' }}
                                          activeClass={details.isActive ? "active" : ""}
                                          vendorName={details.garage && details.garage.companyprofilename}
                                          vendorId={details.garage && details.garage.id}
                                          rating={details.garage.rating}
                                          distance={details.garage.distance ? round(details.garage.distance, 2) : ''}
                                          reviews={details.garage.reviews}
                                          btnClickFunc={this.btnClickFunc.bind(this)}
                                          viewMessaging={(jobId) => { this.viewMessaging(jobId) }}
                                          removeFavourite={this.removeFav.bind()}
                                          ClickedQuoteCard={(vendorId) => {
                                            this.ClickedQuoteCard({ key }, details.garage ? details.garage.id : undefined)
                                          }
                                          } />
                                      );
                                    })}
                                  </div>
                                </div>}

                                {displayname != "Active" && garageQuotesPricingDetails && garageQuotesPricingDetails.garage ? <div>
                                  <AcceptedQuotes vendorDetailsVisible={()=>this.setState({mobJD:''})}  router={router} garageDetails={garageQuotesPricingDetails && garageQuotesPricingDetails.garage} />
                                </div> : ""}
                              </CustomScroll>
                            </div>
                          </div>
                        </div>
                      </div>
                      {(displayname == "Completed" || displayname == "Accepted" || displayname == "In-progress" ||  displayname == "Driver Accepted" || (displayname == "Active" && !this.state.mapView))&&
                      <span className={this.state.currentWidth>991?"":this.state.mobJD==""?"":"hide"}>
                      <div className="quotes-right-header n-emergency">
                      <i className={this.state.currentWidth<900?"mdi mdi-arrow-left":"hide"} onClick={()=>this.setState({mobJD:'job-card'})}></i>
                        <div className="profile-head n-emergency">
                          <span>
                            <img src={`${imageBasePath}/images/pic.png`} alt="" />
                          </span>
                          <label> {garageQuotesPricingDetails && garageQuotesPricingDetails.garage && garageQuotesPricingDetails.garage.companyprofilename} </label>
                        </div>
                        <div className={this.state.currentWidth < 991 ?"hide":"quotes-right-tabs"}>
                          {(displayname == "Accepted" || displayname == "In-progress" || displayname == "Driver Accepted") && <ul>
                            <li className={this.state.quotation ? "active" : ""} onClick={() => this.viewQuotation()}>QUOTE</li>
                            <li className={this.state.mapView ? "active" : ""} onClick={() => this.viewMessages()}>DRIVER DETAIL</li>
                          </ul>}
                          {displayname == "Active" && <a className="close-Tab" onClick={() => this.viewMessages()}><i className="mdi mdi-close" /></a>}
                        </div>
                      </div>
                      </span>}
                      <div className="col-md-6 clearfix right pad0">
                        <div className={this.state.mapView ? this.props.router.params.status_type == "accepted" ? "mapSection queue-card" : "mapSection" : "mapSection hide"}>
                          <div className="quotes-right-body">

                            {this.props.router.params.status_type == "accepted" && <div className="queue-text">
                              <span>Driver has 2 Jobs in Queue.</span>
                              <span>You will be able to track the vehicle once it starts navigating</span>
                              <span>ETA: 30mins</span>
                            </div>}
                            <div className="queue-card-holder">
                              <div className="queue-card">
                                <div className="left">
                                  <Media>
                                    <Media.Left>
                                      <div className="image-holder">
                                        <img src={`${imageBasePath}/images/car.jpg`} alt="audi-a3" />
                                      </div>
                                    </Media.Left>
                                    <Media.Body>
                                      <Media.Heading>Herbert Martin</Media.Heading>
                                      <span className="phone-nbr">+971 919 233 470</span>
                                    </Media.Body>
                                  </Media>
                                </div>
                                <div className="right">
                                  <span className="date-updated">Last Updated :10:35 AM</span>
                                </div>
                              </div>
                            </div>
                            <Gmaps
                              mapDrag={() => { this.setState({ setCenter: false }) }}
                              infoPopUp={true}
                              setCenter={this.state.setCenter}
                              center={this.state.mapsCenter}
                              markers={{ jobCardLocation }}
                              markerClick={this.mapClick.bind(this)}
                              zoom={9}
                              containerElement={<div style={{ height: 100 + '%' }} />}
                              mapElement={<div style={{ height: 100 + '%' }} />}
                            />
                            <span onClick={this.setCenter.bind(this)} className="current-position"><i className="mdi mdi-crosshairs-gps"></i></span>
                          </div>
                        </div>
                        <div className={(this.state.quotationView && garageQuotesPricingDetails && !this.state.mapView && (displayname == "Active" || displayname == "Accepted" || displayname == 'In-progress' || displayname == 'Completed')) ? "quotesSection" : "quotesSection hide"}>

                          <div className="quotes-right-body">
                            <div className="requestQuotesScroll">
                              {/*Quotation*/}
                              <div className={this.state.quotation == true ? "quotes-quotation-Section" : "quotes-quotation-Section hide"}>
                                <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
                                  <div className="quotation-head">
                                    <ul>
                                      <li>
                                        <label>Job Start Time:</label>
                                        <span>{startDate}</span>
                                      </li>
                                      <li>
                                        <label>Quote Generated:</label>
                                        <span>{createdAt}</span>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="quotation-details">
                                    {garageQuotesPricingDetails && garageQuotesPricingDetails.garagejobquotesdetail && map(groupBy(garageQuotesPricingDetails.garagejobquotesdetail, 'parentId'), (cardValue, jobCardKey) => {
                                      if (cardValue && cardValue.length && cardValue[0] && cardValue[0].parentId > 4) {
                                        serviceIndex = serviceIndex + 1;
                                        return (
                                          <div className="quotation-block" key={jobCardKey}>
                                            <div>
                                              <h4>{serviceIndex}. {cardValue[0].parent && cardValue[0].parent.name}</h4>
                                              <ul>
                                                {map(cardValue, (carAcc, accessoriesKey) => {
                                                  return (
                                                    <li key={accessoriesKey}>
                                                      <label>{carAcc.name}</label>
                                                      <span>{carAcc.amount} {carAcc.currency}</span>
                                                    </li>
                                                  );
                                                })}
                                              </ul>
                                            </div>
                                          </div>
                                        );
                                      } else if (cardValue[0]) {
                                        return (
                                          <div className="quotation-block" key={jobCardKey}>
                                            <div>
                                              {/* <h4>{jobCardKey}. {cardValue[0].name}</h4> */}
                                              <ul>
                                                {map(cardValue, (carAcc, accessoriesKey) => {
                                                  return (
                                                    <li key={accessoriesKey}>
                                                      <label>{(accessoriesKey + 1) + '. ' + carAcc.name}</label>
                                                      <span>{carAcc.amount} {carAcc.currency}</span>
                                                    </li>
                                                  );
                                                })}
                                              </ul>
                                            </div>
                                          </div>
                                        );
                                      }
                                    })}
                                    <div className="quotation-total">
                                      <label>Total</label>
                                      <span>{garageQuotesPricingDetails && garageQuotesPricingDetails.totalamount + ' ' + garageQuotesPricingDetails.currency}</span>
                                    </div>
                                    {displayname == "Active" && garageQuotesPricingDetails && garageQuotesPricingDetails.jobdetailstatus && garageQuotesPricingDetails.jobdetailstatus.name != 'Decline' && garageQuotesPricingDetails.jobdetailstatus.name != 'Expired' ? <div className="quotation-accept-btn pull-right">
                                      <Button isButtonLoading={this.state.isButtonLoading} btnSize="sm" fontSize={14} btnType="red" label="Accept Quote" btnCallBack={() => { this.acceptQuotes(vendorQuotesList.id, garageQuotesPricingDetails.id, vendorQuotesList.requestid, router); }} />
                                    </div> : ""}
                                    {displayname == "Active" && garageQuotesPricingDetails && garageQuotesPricingDetails.jobdetailstatus && (garageQuotesPricingDetails.jobdetailstatus.name == 'Decline') ? <div className="declined-msg">This Quote has been declined by vendor.</div> : ""}
                                    {displayname == "Active" && garageQuotesPricingDetails && garageQuotesPricingDetails.jobdetailstatus && (garageQuotesPricingDetails.jobdetailstatus.name == 'Expired') ? <div className="declined-msg">This Quote was expired.</div> : ""}
                                  </div>
                                </CustomScroll>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
